// extracted by mini-css-extract-plugin
export default {"title":"Job_title__m5vFi","description":"Job_description__II2Ef","error":"Job_error__GSG5w","button":"Job_button__kFNeQ"};